import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "xpage-content sc-page-content" }
const _hoisted_2 = { class: "xpage-content-page sc-page-content-page" }
const _hoisted_3 = { class: "xtitlearea sc-titlearea" }
const _hoisted_4 = { class: "xpage-content-page sc-page-content-page" }
const _hoisted_5 = {
  class: "sc-container",
  id: "certification"
}

import { computed } from "vue";
import { CertificationVM, CertificationSlimVM } from "@/types/certifications";
import { DisbursementVM, DisbursementAddedEvent } from "@/types/disbursements";
import Comments from "@/components/v2/certifications/Comments.vue";
import CertificationForm from "@/components/v2/certifications/CertificationForm.vue";
import CertificationsNavbar from "@/components/v2/certifications/CertificationsNavbar.vue";
import DisbursementsSection from "@/components/v2/disbursements/DisbursementsSection.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CertificationsAndDisbursements',
  props: {
    certification: {}
  },
  emits: ["commentAdded", "certificationUpdated", "disbursementUpdated", "disbursementAdded"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const certifications = computed<CertificationSlimVM[]>(
  () => props.certification?.certifications || []
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "sc-page-content-section" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "sc-section-header" }, "Certifications and Disbursements", -1)),
        _createVNode(Comments, {
          certification: __props.certification,
          onCommentAdded: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('commentAdded')))
        }, null, 8, ["certification"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, [
        _createVNode(CertificationsNavbar, { certifications: certifications.value }, null, 8, ["certifications"]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(CertificationForm, {
            certification: __props.certification,
            onCertificationUpdated: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('certificationUpdated', $event)))
          }, null, 8, ["certification"]),
          _createVNode(DisbursementsSection, {
            certification: __props.certification,
            onDisbursementUpdated: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('disbursementUpdated', $event))),
            onDisbursementAdded: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('disbursementAdded', $event)))
          }, null, 8, ["certification"])
        ])
      ])
    ])
  ]))
}
}

})